import React from "react";
import MonetaryUtils from "../../../../shared/utils/MonetaryUtils";

const AssessmentDiscountCell = ({ value }) => {
	const normalizedDiscount =
		MonetaryUtils.normalizePercentage(value);

	const isPositiveDiscount = Number(normalizedDiscount) > 0;

	return (
		<span
			className={[
				"apuracao-table__granted-discount",
				isPositiveDiscount
					? "apuracao-table__granted-discount--positive"
					: ""
			].filter(Boolean).join(" ")}
		>
			{MonetaryUtils.formatPercentage(value)}
		</span>
	);
};

export default AssessmentDiscountCell;